import axios from 'axios';

//고객 관련 store
const customerStore = {
    state: {
      //고객 정보(치과)
      dCustomerInfo: [],
      dCustomerInfoOrigin: [],

      //고객 정보(지문)
      fCustomerInfo: [],
      fCustomerInfoOrigin: [],

      //고객 정보(펫)
      pCustomerInfo: [],
      pCustomerInfoOrigin: [],

      //고객 정보(SNS)
      sCustomerInfo: [],
      sCustomerInfoOrigin: [],
      sCustomerInfoNoPlanner: [],

      //고객 정보(동물병원)
      hCustomerInfo: [],
      hCustomerInfoOrigin: [],

      noPlannerCustomerCount: 0,
  
      //상담/체결 현황 조회 기간 state
      statisticPeriod: ['', ''],
  
      //일자별 고객 등록/체결 현황 state
      dateParam01: 0,
      dateParam02: 0, //현재 날짜에서 몇 달을 뺄지
      dateParam03: '', //dateParam02로 계산한 현재 연.월.
  
      //검색어
      searchText: '',

      //즐겨찾기 보기 여부
      isFavorite: false,
  
      //DB 구분
      dbKind: 'all',
    },
    mutations: {
      setCustomerInfo(state, data) {
        data = data.sort((a, b) => b._id - a._id); // _id 값으로 내림차순 정렬

        if(state.dbKind == 'dental'){
          state.dCustomerInfoOrigin = data;
        }else if(state.dbKind == 'finger'){
          state.fCustomerInfoOrigin = data;
        }else if(state.dbKind == 'pet'){
          state.pCustomerInfoOrigin = data;
        }else if(state.dbKind == 'sns'){
          state.sCustomerInfoOrigin = data;
        }else if(state.dbKind == 'hospital'){
          state.hCustomerInfoOrigin = data;
        }else{
          state.dCustomerInfoOrigin = data.filter(a => a.db_kind == 'dental');
          state.fCustomerInfoOrigin = data.filter(a => a.db_kind == 'finger');
          state.pCustomerInfoOrigin = data.filter(a => a.db_kind == 'pet');
          state.sCustomerInfoOrigin = data.filter(a => a.db_kind == 'sns');
          state.hCustomerInfoOrigin = data.filter(a => a.db_kind == 'hospital');
        }

        state.searchText = '';
      },
  
      refreshCustomerInfo(state, data){
        data = data.sort((a, b) => b._id - a._id); // _id 값으로 내림차순 정렬

        if(state.dbKind == 'dental'){
          state.dCustomerInfoOrigin = data;
        }else if(state.dbKind == 'finger'){
          state.fCustomerInfoOrigin = data;
        }else if(state.dbKind == 'pet'){
          state.pCustomerInfoOrigin = data;
        }else if(state.dbKind == 'sns'){
          state.sCustomerInfoOrigin = data;
        }else if(state.dbKind == 'hospital'){
          state.hCustomerInfoOrigin = data;
        }else{
          state.dCustomerInfoOrigin = data.filter(a => a.db_kind == 'dental');
          state.fCustomerInfoOrigin = data.filter(a => a.db_kind == 'finger');
          state.pCustomerInfoOrigin = data.filter(a => a.db_kind == 'pet');
          state.sCustomerInfoOrigin = data.filter(a => a.db_kind == 'sns');
          state.hCustomerInfoOrigin = data.filter(a => a.db_kind == 'hospital');
        }
      },

      setNoPlannerCustomerInfo(state, data) {
        state.noPlannerCustomerCount = data.length;
        state.sCustomerInfoNoPlanner = data;
      },
  
      decDateParam01(state){
        state.dateParam01--;
      },
  
      incDateParam01(state){
        state.dateParam01++;
      },
  
      decDateParam02(state){
        state.dateParam02++;
      },
  
      incDateParam02(state){
        state.dateParam02--;
      },
  
      setDBKind(state, data){
        state.dbKind = data;
      },
    },
    actions: {
      //고객 정보 조회
      async getCustomerInfo(context) {
        this.state.common.isLoading = true;
        axios.get(`/customer/list/${context.state.dbKind}?t=${this.state.login.userType}&n=${this.state.login.userName}`,{
            headers: {
                        'Authorization': context.rootGetters.getCryptNum
            }
          })
          .then((res) => {
            context.commit('setCustomerInfo', res.data);
            this.state.common.isLoading = false;
          })
          .catch((error) => {
            context.commit('setAlert', {  'alertStatus': 'error'
                                          ,'alertTitle': '고객 정보 조회'
                                          ,'alertContent': `오류 발생|${error}`});
          })
      },
  
      //고객 정보 갱신(입력/수정 시, Original만 수정)
      async refreshCustomerInfo(context){
        axios.get(`/customer/list/${context.state.dbKind}?t=${this.state.login.userType}&n=${this.state.login.userName}`,{
          headers: {
                      'Authorization': context.rootGetters.getCryptNum
          }
        })
        .then((res) => {
          context.commit('refreshCustomerInfo', res.data);
        })
        .catch((error) => {
          context.commit('setAlert', {  'alertStatus': 'error'
                                        ,'alertTitle': '고객 정보 갱신'
                                        ,'alertContent': `오류 발생|${error}`});
        })
      },

      //플래너 미할당 고객 정보 조회(SNS 고객만 해당)
      async getNoPlannerCustomerInfo(context) {
        axios.get(`/customer/list/noplanner/sns`)
        .then((res) => {
          context.commit('setNoPlannerCustomerInfo', res.data);
        })
        .catch((error) => {
          context.commit('setAlert', {  'alertStatus': 'error'
                                        ,'alertTitle': '플래너 미할당 고객 정보 조회(SNS)'
                                        ,'alertContent': `오류 발생|${error}`});
        })
      },
  
      //고객 정보 입력
      async insertCustomerInfo(context, data) {
        let formData = new FormData();
  
        if(!data.attach_file.length){
          formData.append('files', []);
        }
  
        for (let i = 0; i < data.attach_file.length; i++) {
          const file = data.attach_file[i];
          formData.append('files', file, encodeURIComponent(file.name));
        }

        if(context.state.dbKind == 'dental'){
          formData.append('isReside', JSON.stringify(data.isReside));
          formData.append('isFavorite', JSON.stringify(data.isFavorite));
          formData.append('name', data.name);
          formData.append('regist_number', data.regist_number);
          formData.append('phone', JSON.stringify(data.phone));
          formData.append('address', JSON.stringify(data.address));
          formData.append('bank_info', JSON.stringify(data.bank_info));
          formData.append('planner', JSON.stringify(data.planner));
          formData.append('complain', JSON.stringify(data.complain));
          formData.append('status', JSON.stringify(data.status));
          formData.append('memo', JSON.stringify(data.memo));
          formData.append('memoDate', JSON.stringify(data.memoDate));
          formData.append('contract', JSON.stringify(data.contract));
          formData.append('hospital_info', JSON.stringify(data.hospital_info));
          formData.append('insert_date', data.insert_date);
          formData.append('insert_id', data.insert_id);
          formData.append('db_kind', this.state.customer.dbKind);
        }else if(context.state.dbKind == 'finger'){
          formData.append('isFavorite', JSON.stringify(data.isFavorite));
          formData.append('pName', data.pName);
          formData.append('cName', data.cName);
          formData.append('phone', JSON.stringify(data.phone));
          formData.append('area', data.area);
          formData.append('childProp', data.childProp);
          formData.append('as', data.as);
          formData.append('planner', JSON.stringify(data.planner));
          formData.append('memo', JSON.stringify(data.memo));
          formData.append('memoDate', JSON.stringify(data.memoDate));
          formData.append('contract', JSON.stringify(data.contract));
          formData.append('insert_date', data.insert_date);
          formData.append('insert_id', data.insert_id);
          formData.append('db_kind', this.state.customer.dbKind);
        }else if(context.state.dbKind == 'pet'){
          formData.append('isFavorite', JSON.stringify(data.isFavorite));
          formData.append('name', data.name);
          formData.append('regist_number', data.regist_number);
          formData.append('phone', JSON.stringify(data.phone));
          formData.append('address', JSON.stringify(data.address));
          formData.append('job', JSON.stringify(data.job));
          formData.append('petInfo', JSON.stringify(data.petInfo));
          formData.append('planner', JSON.stringify(data.planner));
          formData.append('memo', JSON.stringify(data.memo));
          formData.append('memoDate', JSON.stringify(data.memoDate));
          formData.append('contract', JSON.stringify(data.contract));
          formData.append('payment', JSON.stringify(data.payment));
          formData.append('insert_date', data.insert_date);
          formData.append('insert_id', data.insert_id);
          formData.append('db_kind', this.state.customer.dbKind);
        }else if(context.state.dbKind == 'sns'){
          formData.append('isFavorite', JSON.stringify(data.isFavorite));
          formData.append('name', data.name);
          formData.append('regist_number', data.regist_number);
          formData.append('phone', JSON.stringify(data.phone));
          formData.append('address', JSON.stringify(data.address));
          formData.append('job', JSON.stringify(data.job));
          formData.append('petInfo', JSON.stringify(data.petInfo));
          formData.append('insuInfo', JSON.stringify(data.insuInfo));
          formData.append('planner', JSON.stringify(data.planner));
          formData.append('memo', JSON.stringify(data.memo));
          formData.append('memoDate', JSON.stringify(data.memoDate));
          formData.append('contract', JSON.stringify(data.contract));
          formData.append('payment', JSON.stringify(data.payment));
          formData.append('insert_date', data.insert_date);
          formData.append('insert_id', data.insert_id);
          formData.append('db_kind', this.state.customer.dbKind);
        }else if(context.state.dbKind == 'hospital'){
          formData.append('isReside', JSON.stringify(data.isReside));
          formData.append('isFavorite', JSON.stringify(data.isFavorite));
          formData.append('name', data.name);
          formData.append('regist_number', data.regist_number);
          formData.append('phone', JSON.stringify(data.phone));
          formData.append('address', JSON.stringify(data.address));
          formData.append('bank_info', JSON.stringify(data.bank_info));
          formData.append('planner', JSON.stringify(data.planner));
          formData.append('complain', JSON.stringify(data.complain));
          formData.append('status', JSON.stringify(data.status));
          formData.append('petInfo', JSON.stringify(data.petInfo));
          formData.append('memo', JSON.stringify(data.memo));
          formData.append('memoDate', JSON.stringify(data.memoDate));
          formData.append('contract', JSON.stringify(data.contract));
          formData.append('hospital', JSON.stringify(data.hospital));
          formData.append('insert_date', data.insert_date);
          formData.append('insert_id', data.insert_id);
          formData.append('db_kind', this.state.customer.dbKind);
        }else {
          return;
        }
  
        await axios.post(`/customer/insert/${context.state.dbKind}`, formData, {
          headers: {
                      'Authorization': context.rootGetters.getCryptNum
          }
        })
          .then((res) => {
            if(res.data.result == 'success'){
              context.commit('setAlert', {  'alertStatus': 'notice'
                                            ,'alertTitle': '고객 정보 입력'
                                            ,'alertContent': res.data.message});
                context.dispatch('refreshCustomerInfo');
                context.dispatch('getNoPlannerCustomerInfo');
            }
          })
          .catch((error) => {
            context.commit('setAlert', {  'alertStatus': 'error'
                                          ,'alertTitle': '고객 정보 입력'
                                          ,'alertContent': `오류 발생|${error}`});
          })
      },
  
      //고객 정보 수정
      async modifyCustomerInfo(context, data) {
        let formData = new FormData();
  
        if(!data.attach_file.length){
          formData.append('files', []);
        }
  
        for (let i = 0; i < data.attach_file.length; i++) {
          const file = data.attach_file[i];
          formData.append('files', file, encodeURIComponent(file.name));
        }

        if(context.state.dbKind == 'dental'){
          formData.append('_id', data._id);
          formData.append('isReside', JSON.stringify(data.isReside));
          formData.append('isFavorite', JSON.stringify(data.isFavorite));
          formData.append('name', data.name);
          formData.append('regist_number', data.regist_number);
          formData.append('phone', JSON.stringify(data.phone));
          formData.append('address', JSON.stringify(data.address));
          formData.append('bank_info', JSON.stringify(data.bank_info));
          formData.append('planner', JSON.stringify(data.planner));
          formData.append('complain', JSON.stringify(data.complain));
          formData.append('status', JSON.stringify(data.status));
          formData.append('memo', JSON.stringify(data.memo));
          formData.append('memoDate', JSON.stringify(data.memoDate));
          formData.append('cur_attach_file', JSON.stringify(data.cur_attach_file));
          formData.append('contract', JSON.stringify(data.contract));
          formData.append('hospital_info', JSON.stringify(data.hospital_info));
          formData.append('update_date', data.update_date);
          formData.append('update_id', data.update_id);
        }else if(context.state.dbKind == 'finger'){
          formData.append('_id', data._id);
          formData.append('isFavorite', JSON.stringify(data.isFavorite));
          formData.append('pName', data.pName);
          formData.append('cName', data.cName);
          formData.append('phone', JSON.stringify(data.phone));
          formData.append('area', data.area);
          formData.append('childProp', data.childProp);
          formData.append('as', data.as);
          formData.append('planner', JSON.stringify(data.planner));
          formData.append('memo', JSON.stringify(data.memo));
          formData.append('memoDate', JSON.stringify(data.memoDate));
          formData.append('cur_attach_file', JSON.stringify(data.cur_attach_file));
          formData.append('contract', JSON.stringify(data.contract));
          formData.append('update_date', data.update_date);
          formData.append('update_id', data.update_id);
        }else if(context.state.dbKind == 'pet'){
          formData.append('_id', data._id);
          formData.append('isFavorite', JSON.stringify(data.isFavorite));
          formData.append('name', data.name);
          formData.append('regist_number', data.regist_number);
          formData.append('phone', JSON.stringify(data.phone));
          formData.append('address', JSON.stringify(data.address));
          formData.append('job', JSON.stringify(data.job));
          formData.append('petInfo', JSON.stringify(data.petInfo));
          formData.append('planner', JSON.stringify(data.planner));
          formData.append('memo', JSON.stringify(data.memo));
          formData.append('memoDate', JSON.stringify(data.memoDate));
          formData.append('cur_attach_file', JSON.stringify(data.cur_attach_file));
          formData.append('contract', JSON.stringify(data.contract));
          formData.append('payment', JSON.stringify(data.payment));
          formData.append('update_date', data.insert_date);
          formData.append('update_id', data.insert_id);
        }else if(context.state.dbKind == 'sns'){
          formData.append('_id', data._id);
          formData.append('isFavorite', JSON.stringify(data.isFavorite));
          formData.append('name', data.name);
          formData.append('regist_number', data.regist_number);
          formData.append('phone', JSON.stringify(data.phone));
          formData.append('address', JSON.stringify(data.address));
          formData.append('job', JSON.stringify(data.job));
          formData.append('petInfo', JSON.stringify(data.petInfo));
          formData.append('insuInfo', JSON.stringify(data.insuInfo));
          formData.append('planner', JSON.stringify(data.planner));
          formData.append('memo', JSON.stringify(data.memo));
          formData.append('memoDate', JSON.stringify(data.memoDate));
          formData.append('cur_attach_file', JSON.stringify(data.cur_attach_file));
          formData.append('contract', JSON.stringify(data.contract));
          formData.append('payment', JSON.stringify(data.payment));
          formData.append('update_date', data.insert_date);
          formData.append('update_id', data.insert_id);
        }else if(context.state.dbKind == 'hospital'){
          formData.append('_id', data._id);
          formData.append('isReside', JSON.stringify(data.isReside));
          formData.append('isFavorite', JSON.stringify(data.isFavorite));
          formData.append('name', data.name);
          formData.append('regist_number', data.regist_number);
          formData.append('phone', JSON.stringify(data.phone));
          formData.append('address', JSON.stringify(data.address));
          formData.append('bank_info', JSON.stringify(data.bank_info));
          formData.append('planner', JSON.stringify(data.planner));
          formData.append('complain', JSON.stringify(data.complain));
          formData.append('status', JSON.stringify(data.status));
          formData.append('petInfo', JSON.stringify(data.petInfo));
          formData.append('memo', JSON.stringify(data.memo));
          formData.append('memoDate', JSON.stringify(data.memoDate));
          formData.append('contract', JSON.stringify(data.contract));
          formData.append('hospital', JSON.stringify(data.hospital));
          formData.append('update_date', data.insert_date);
          formData.append('update_id', data.insert_id);
        }else{
          return;
        }

        axios.post(`/customer/update/${context.state.dbKind}`, formData, {
          headers: {
                      'Authorization': context.rootGetters.getCryptNum
          }
        })
          .then((res) => {
            if(res.data.result == 'success'){
              context.commit('setAlert', {  'alertStatus': 'notice'
                                              ,'alertTitle': '고객 정보 수정'
                                              ,'alertContent': res.data.message});
              context.dispatch('refreshCustomerInfo');
              context.dispatch('getNoPlannerCustomerInfo');
            }
          })
          .catch((error) => {
            context.commit('setAlert', {  'alertStatus': 'error'
                                          ,'alertTitle': '고객 정보 수정'
                                          ,'alertContent': `오류 발생|${error}`});
            //console.log(error);
          })
      },
  
      //고객 정보 삭제
      async deleteCustomerInfo(context, data){
        axios.post(`/customer/delete/${context.state.dbKind}`, {
          '_id': data.id
        }, {
          headers: {
                      'Authorization': context.rootGetters.getCryptNum
          }
        })
        .then((res) => {
          if(res.data.result == 'success'){
            context.commit('setAlert', {  'alertStatus': 'notice'
                                            ,'alertTitle': '고객 정보 삭제'
                                            ,'alertContent': res.data.message});
            context.dispatch('refreshCustomerInfo');
            context.dispatch('getNoPlannerCustomerInfo');
          }
        })
        .catch((error) => {
          context.commit('setAlert', {  'alertStatus': 'error'
                                          ,'alertTitle': '고객 정보 삭제'
                                          ,'alertContent': `오류 발생|${error}`});
        })
      },
      
    },
    getters: {
      //메인페이지 치과 고객 수
      getDentalTotalCount(state){
        let total = state.dCustomerInfoOrigin.length;
        let thisMonth = state.dCustomerInfoOrigin.filter((a) => (+a.insert_date.replaceAll(' ', '').split('.')[0] == new Date().getFullYear()) && (+a.insert_date.replaceAll(' ', '').split('.')[1] == new Date().getMonth() + 1)).length;
        return `${total}/${thisMonth}`;
      },
  
      //메인페이지 지문 고객 수
      getFingerTotalCount(state){
        let total = state.fCustomerInfoOrigin.length;
        let thisMonth = state.fCustomerInfoOrigin.filter((a) => (+a.insert_date.replaceAll(' ', '').split('.')[0] == new Date().getFullYear()) && (+a.insert_date.replaceAll(' ', '').split('.')[1] == new Date().getMonth() + 1)).length;
        return `${total}/${thisMonth}`;
      },

      //메인페이지 펫 고객 수
      getPetTotalCount(state){
        let total = state.pCustomerInfoOrigin.length;
        let thisMonth = state.pCustomerInfoOrigin.filter((a) => (+a.insert_date.replaceAll(' ', '').split('.')[0] == new Date().getFullYear()) && (+a.insert_date.replaceAll(' ', '').split('.')[1] == new Date().getMonth() + 1)).length;
        return `${total}/${thisMonth}`;
      },

      //메인페이지 SNS 고객 수
      getSnsTotalCount(state){
        let total = state.sCustomerInfoOrigin.length;
        let thisMonth = state.sCustomerInfoOrigin.filter((a) => (+a.insert_date.replaceAll(' ', '').split('.')[0] == new Date().getFullYear()) && (+a.insert_date.replaceAll(' ', '').split('.')[1] == new Date().getMonth() + 1)).length;
        return `${total}/${thisMonth}`;
      },

      //메인페이지 동물병원 고객 수
      getHospitalTotalCount(state){
        let total = state.hCustomerInfoOrigin.length;
        let thisMonth = state.hCustomerInfoOrigin.filter((a) => (+a.insert_date.replaceAll(' ', '').split('.')[0] == new Date().getFullYear()) && (+a.insert_date.replaceAll(' ', '').split('.')[1] == new Date().getMonth() + 1)).length;
        return `${total}/${thisMonth}`;
      },
  
      //(미사용)메인페이지 플래너별 등록/체결 현황
      getPlannerStatistics_old(state){
        let temp = {};
        let result = [];
  
        //console.log(`1. state.statisticPeriod: ${new Date(state.statisticPeriod[0]).toLocaleDateString()}/${new Date(state.statisticPeriod[1]).toLocaleDateString()}`);
  
        //전체 기간인지??
        let isTotalPeriod = (state.statisticPeriod[0] == '' && state.statisticPeriod[1] == '');
  
        //console.log(`2. isTotalPeriod: ${isTotalPeriod}`);
  
        //각 플래너의 고객 정보 입력
        state.customerInfoOrigin.reduce((acc, cur) => {
          //console.log(`**** id:${cur._id} / planner: ${cur.planner.planner01.planner_name} / conFlag: ${cur.contract.flag}`);
          let [yy, mm, dd] = cur.insert_date.split('.');
          let ins_dt = new Date(yy, mm - 1, dd).getTime();
          
          //console.log(`3. cur.insert_date: ${cur.insert_date}`);
  
          //입력일이 조회 기간에 포함되는지?
          let isPeriod = (state.statisticPeriod[0] <= ins_dt && ins_dt <= state.statisticPeriod[1]);
  
          //console.log(`4. isPeriod: ${isPeriod}`);
  
          if( isTotalPeriod || isPeriod ){
            let planner = cur.planner.planner01.planner_name;
  
            if(!temp[planner]){
              temp[planner] = {
                name: planner
                ,customer_cnt: 0
                ,contract_cnt: 0
                ,contract_ratio: 0
                ,price_total: 0
                ,price_avg: 0
              }
            }
            
            //고객수 ++
            temp[planner].customer_cnt = Number(temp[planner].customer_cnt) + 1;
            
            //console.log(`5. cur.contract.flag: ${cur.contract.flag}`);
            
            //계약체결 여부 확인해서 체결수 ++ / 보험료 ++
            if(cur.contract.flag){
              let con_dt = new Date(cur.contract.date).getTime();
  
              //console.log(`6. cur.contract.date: ${cur.contract.date}`);
              //console.log(`7. isContractDate Valid: ${(state.statisticPeriod[0] < con_dt && con_dt < state.statisticPeriod[1])}`);
  
              if(isTotalPeriod || (state.statisticPeriod[0] <= con_dt && con_dt <= state.statisticPeriod[1])){
                temp[planner].contract_cnt = Number(temp[planner].contract_cnt) + 1;
                temp[planner].price_total = Number(temp[planner].price_total) + Number(cur.contract.price.replaceAll(',', ''));
              }
            }
          }
        }, 0)
  
        //체결률, 보험료 평균 값 계산
        Object.keys(temp).forEach((val) => {
          temp[val].contract_ratio = ((temp[val].contract_cnt / temp[val].customer_cnt)*100).toFixed(2);
          temp[val].price_avg = temp[val].contract_cnt?(temp[val].price_total / temp[val].contract_cnt).toFixed(0):0;
          result.push(temp[val]);
        })
  
        //정렬()
        result.sort((a, b) => {
          //우선순위에 따른 정렬
          //1. 보험료계
          if(+(b.price_total) > +(a.price_total)) return 1;
          if(+(b.price_total) < +(a.price_total)) return -1;
  
          //2. 체결건수
          if(+(b.contract_cnt) > +(a.contract_cnt)) return 1;
          if(+(b.contract_cnt) < +(a.contract_cnt)) return -1;
  
          //3. 체결률
          if(+(b.contract_ratio) > +(a.contract_ratio)) return 1;
          if(+(b.contract_ratio) < +(a.contract_ratio)) return -1;
  
          //4. 평균 보험료
          if(+(b.price_avg) > +(a.price_avg)) return 1;
          if(+(b.price_avg) < +(a.price_avg)) return -1;
  
          //5. 고객수
          if(+(b.customer_cnt) > +(a.customer_cnt)) return 1;
          if(+(b.customer_cnt) < +(a.customer_cnt)) return -1;
          
          return 0;
        })
  
        return result;
      },
  
      //메인페이지 플래너별 등록/체결 현황(전체)
      getAllPlannerStatistics(state){
        let temp = {};
        let result = [];
        let dt = new Date();

        dt.setDate(1); //오늘이 31일인 경우, setMonth로 1달을 뺄 경우 전달의 31일이 돼서 다시 이번달 1일이 돼버림.. 그래서 그 전에 '일'을 1일로 변경!
  
        dt.setMonth(dt.getMonth() - state.dateParam02);
        
        let [year, month] = dt.toLocaleDateString().replaceAll(' ', '').split('.');
        let dateParam = `${year}${month}`;
        state.dateParam03 = `${year}년 ${month}월`;
        
        let aCustomerInfoOrigin = [...state.dCustomerInfoOrigin, ...state.fCustomerInfoOrigin, ...state.pCustomerInfoOrigin, ...state.sCustomerInfoOrigin, ...state.hCustomerInfoOrigin];

        //각 플래너의 고객 정보 입력
        aCustomerInfoOrigin.reduce((_, cur) => {
          let [yy, mm] = cur.insert_date.replaceAll(' ', '').split('.');
          let ins_dt = yy + '' + mm;
  
          //입력일이 설정된 달에 해당하는지
          let isPeriod = (ins_dt == dateParam);

          //플래너
          let planner = cur.planner.planner01.planner_name;

          if(!temp[planner]){
            temp[planner] = {
              name: planner
              ,customer_cnt: 0
              ,contract_cnt: 0
              ,contract_ratio: 0
              ,price_total: 0
              ,price_avg: 0
            }
          }
          
          if(isPeriod){
            //고객수 ++
            temp[planner].customer_cnt = Number(temp[planner].customer_cnt) + 1;
          }

          //계약체결정보
          for(let i = 0; i < cur.contract.length; i++){
            //계약체결 여부 확인해서 체결수 ++ / 보험료 ++
            if(cur.contract[i].flag){
              let [conYY, conMM] = cur.contract[i].date.replaceAll(' ', '').split('.');
              let con_dt = conYY + '' + conMM;
              
              if(con_dt == dateParam){
                temp[planner].contract_cnt = Number(temp[planner].contract_cnt) + 1;
                temp[planner].price_total = Number(temp[planner].price_total) + Number(cur.contract[i].price.replaceAll(',', ''));
              }
            }
          }

        }, 0)
  
        //체결률, 보험료 평균 값 계산
        Object.keys(temp).forEach((val) => {
          temp[val].contract_ratio = temp[val].customer_cnt?((temp[val].contract_cnt / temp[val].customer_cnt)*100).toFixed(2):0;
          temp[val].price_avg = temp[val].contract_cnt?(temp[val].price_total / temp[val].contract_cnt).toFixed(0):0;
          result.push(temp[val]);
        })
  
        //등록 고객 or 체결 고객이 한 명이라도 있는 것만 출력
        result = result.filter((a) => a.customer_cnt != 0 || a.contract_cnt != 0);

        //정렬()
        result.sort((a, b) => {
          //우선순위에 따른 정렬
          //1. 보험료계
          if(+(b.price_total) > +(a.price_total)) return 1;
          if(+(b.price_total) < +(a.price_total)) return -1;
  
          //2. 체결건수
          if(+(b.contract_cnt) > +(a.contract_cnt)) return 1;
          if(+(b.contract_cnt) < +(a.contract_cnt)) return -1;
  
          //3. 체결률
          if(+(b.contract_ratio) > +(a.contract_ratio)) return 1;
          if(+(b.contract_ratio) < +(a.contract_ratio)) return -1;
  
          //4. 평균 보험료
          if(+(b.price_avg) > +(a.price_avg)) return 1;
          if(+(b.price_avg) < +(a.price_avg)) return -1;
  
          //5. 고객수
          if(+(b.customer_cnt) > +(a.customer_cnt)) return 1;
          if(+(b.customer_cnt) < +(a.customer_cnt)) return -1;
          
          return 0;
        })
  
        return result;
      },
  
      //메인페이지 플래너별 등록/체결 현황(치과)
      getDentalPlannerStatistics(state){
        let temp = {};
        let result = [];
        let dt = new Date();
  
        dt.setDate(1); //오늘이 31일인 경우, setMonth로 1달을 뺄 경우 전달의 31일이 돼서 다시 이번달 1일이 돼버림.. 그래서 그 전에 '일'을 1일로 변경!
  
        dt.setMonth(dt.getMonth() - state.dateParam02);
  
        let [year, month] = dt.toLocaleDateString().replaceAll(' ', '').split('.');
        let dateParam = `${year}${month}`;
        state.dateParam03 = `${year}년 ${month}월`;
  
        //각 플래너의 고객 정보 입력
        state.dCustomerInfoOrigin.reduce((_, cur) => {
          let [yy, mm] = cur.insert_date.replaceAll(' ', '').split('.');
          let ins_dt = yy + '' + mm;
  
          //입력일이 설정된 달에 해당하는지
          let isPeriod = (ins_dt == dateParam);
          
          //플래너
          let planner = cur.planner.planner01.planner_name;

          if(!temp[planner]){
            temp[planner] = {
              name: planner
              ,customer_cnt: 0
              ,contract_cnt: 0
              ,contract_ratio: 0
              ,price_total: 0
              ,price_avg: 0
            }
          }
          
          if(isPeriod){
            //고객수 ++
            temp[planner].customer_cnt = Number(temp[planner].customer_cnt) + 1;
          }

          //계약체결정보
          for(let i = 0; i < cur.contract.length; i++){
            //계약체결 여부 확인해서 체결수 ++ / 보험료 ++
            if(cur.contract[i].flag){
              let [conYY, conMM] = cur.contract[i].date.replaceAll(' ', '').split('.');
              let con_dt = conYY + '' + conMM;
              
              if(con_dt == dateParam){
                temp[planner].contract_cnt = Number(temp[planner].contract_cnt) + 1;
                temp[planner].price_total = Number(temp[planner].price_total) + Number(cur.contract[i].price.replaceAll(',', ''));
              }
            }
          }
        }, 0)
  
        //체결률, 보험료 평균 값 계산
        Object.keys(temp).forEach((val) => {
          temp[val].contract_ratio = temp[val].customer_cnt?((temp[val].contract_cnt / temp[val].customer_cnt)*100).toFixed(2):0;
          temp[val].price_avg = temp[val].contract_cnt?(temp[val].price_total / temp[val].contract_cnt).toFixed(0):0;
          result.push(temp[val]);
        })
  
        //등록 고객 or 체결 고객이 한 명이라도 있는 것만 출력
        result = result.filter((a) => a.customer_cnt != 0 || a.contract_cnt != 0);

        //정렬()
        result.sort((a, b) => {
          //우선순위에 따른 정렬
          //1. 보험료계
          if(+(b.price_total) > +(a.price_total)) return 1;
          if(+(b.price_total) < +(a.price_total)) return -1;
  
          //2. 체결건수
          if(+(b.contract_cnt) > +(a.contract_cnt)) return 1;
          if(+(b.contract_cnt) < +(a.contract_cnt)) return -1;
  
          //3. 체결률
          if(+(b.contract_ratio) > +(a.contract_ratio)) return 1;
          if(+(b.contract_ratio) < +(a.contract_ratio)) return -1;
  
          //4. 평균 보험료
          if(+(b.price_avg) > +(a.price_avg)) return 1;
          if(+(b.price_avg) < +(a.price_avg)) return -1;
  
          //5. 고객수
          if(+(b.customer_cnt) > +(a.customer_cnt)) return 1;
          if(+(b.customer_cnt) < +(a.customer_cnt)) return -1;
          
          return 0;
        })
  
        return result;
      },

      //메인페이지 플래너별 등록/체결 현황(지문)
      getFingerPlannerStatistics(state){
        let temp = {};
        let result = [];
        let dt = new Date();
        
        dt.setDate(1); //오늘이 31일인 경우, setMonth로 1달을 뺄 경우 전달의 31일이 돼서 다시 이번달 1일이 돼버림.. 그래서 그 전에 '일'을 1일로 변경!
  
        dt.setMonth(dt.getMonth() - state.dateParam02);
        
        let [year, month] = dt.toLocaleDateString().replaceAll(' ', '').split('.');
        let dateParam = `${year}${month}`;
        state.dateParam03 = `${year}년 ${month}월`;
        
        //각 플래너의 고객 정보 입력
        state.fCustomerInfoOrigin.reduce((_, cur) => {
          let [yy, mm] = cur.insert_date.replaceAll(' ', '').split('.');
          let ins_dt = yy + '' + mm;
  
          //입력일이 설정된 달에 해당하는지
          let isPeriod = (ins_dt == dateParam);
  
          //플래너
          let planner = cur.planner.planner01.planner_name;

          if(!temp[planner]){
            temp[planner] = {
              name: planner
              ,customer_cnt: 0
              ,contract_cnt: 0
              ,contract_ratio: 0
              ,price_total: 0
              ,price_avg: 0
            }
          }
          
          if(isPeriod){
            //고객수 ++
            temp[planner].customer_cnt = Number(temp[planner].customer_cnt) + 1;
          }

          //계약체결정보
          for(let i = 0; i < cur.contract.length; i++){
            //계약체결 여부 확인해서 체결수 ++ / 보험료 ++
            if(cur.contract[i].flag){
              let [conYY, conMM] = cur.contract[i].date.replaceAll(' ', '').split('.');
              let con_dt = conYY + '' + conMM;
              
              if(con_dt == dateParam){
                temp[planner].contract_cnt = Number(temp[planner].contract_cnt) + 1;
                temp[planner].price_total = Number(temp[planner].price_total) + Number(cur.contract[i].price.replaceAll(',', ''));
              }
            }
          }
        }, 0)
  
        //체결률, 보험료 평균 값 계산
        Object.keys(temp).forEach((val) => {
          temp[val].contract_ratio = temp[val].customer_cnt?((temp[val].contract_cnt / temp[val].customer_cnt)*100).toFixed(2):0;
          temp[val].price_avg = temp[val].contract_cnt?(temp[val].price_total / temp[val].contract_cnt).toFixed(0):0;
          result.push(temp[val]);
        })
  
        //등록 고객 or 체결 고객이 한 명이라도 있는 것만 출력
        result = result.filter((a) => a.customer_cnt != 0 || a.contract_cnt != 0);

        //정렬()
        result.sort((a, b) => {
          //우선순위에 따른 정렬
          //1. 보험료계
          if(+(b.price_total) > +(a.price_total)) return 1;
          if(+(b.price_total) < +(a.price_total)) return -1;
  
          //2. 체결건수
          if(+(b.contract_cnt) > +(a.contract_cnt)) return 1;
          if(+(b.contract_cnt) < +(a.contract_cnt)) return -1;
  
          //3. 체결률
          if(+(b.contract_ratio) > +(a.contract_ratio)) return 1;
          if(+(b.contract_ratio) < +(a.contract_ratio)) return -1;
  
          //4. 평균 보험료
          if(+(b.price_avg) > +(a.price_avg)) return 1;
          if(+(b.price_avg) < +(a.price_avg)) return -1;
  
          //5. 고객수
          if(+(b.customer_cnt) > +(a.customer_cnt)) return 1;
          if(+(b.customer_cnt) < +(a.customer_cnt)) return -1;
          
          return 0;
        })
  
        return result;
      },

      //메인페이지 플래너별 등록/체결 현황(펫)
      getPetPlannerStatistics(state){
        let temp = {};
        let result = [];
        let dt = new Date();
        
        dt.setDate(1); //오늘이 31일인 경우, setMonth로 1달을 뺄 경우 전달의 31일이 돼서 다시 이번달 1일이 돼버림.. 그래서 그 전에 '일'을 1일로 변경!
  
        dt.setMonth(dt.getMonth() - state.dateParam02);
        
        let [year, month] = dt.toLocaleDateString().replaceAll(' ', '').split('.');
        let dateParam = `${year}${month}`;
        state.dateParam03 = `${year}년 ${month}월`;
        
        //각 플래너의 고객 정보 입력
        state.pCustomerInfoOrigin.reduce((_, cur) => {
          let [yy, mm] = cur.insert_date.replaceAll(' ', '').split('.');
          let ins_dt = yy + '' + mm;
  
          //입력일이 설정된 달에 해당하는지
          let isPeriod = (ins_dt == dateParam);
  
          //플래너
          let planner = cur.planner.planner01.planner_name;

          if(!temp[planner]){
            temp[planner] = {
              name: planner
              ,customer_cnt: 0
              ,contract_cnt: 0
              ,contract_ratio: 0
              ,price_total: 0
              ,price_avg: 0
            }
          }
          
          if(isPeriod){
            //고객수 ++
            temp[planner].customer_cnt = Number(temp[planner].customer_cnt) + 1;
          }

          //계약체결정보
          for(let i = 0; i < cur.contract.length; i++){
            //계약체결 여부 확인해서 체결수 ++ / 보험료 ++
            if(cur.contract[i].flag){
              let [conYY, conMM] = cur.contract[i].date.replaceAll(' ', '').split('.');
              let con_dt = conYY + '' + conMM;
              
              if(con_dt == dateParam){
                temp[planner].contract_cnt = Number(temp[planner].contract_cnt) + 1;
                temp[planner].price_total = Number(temp[planner].price_total) + Number(cur.contract[i].price.replaceAll(',', ''));
              }
            }
          }
        }, 0)
  
        //체결률, 보험료 평균 값 계산
        Object.keys(temp).forEach((val) => {
          temp[val].contract_ratio = temp[val].customer_cnt?((temp[val].contract_cnt / temp[val].customer_cnt)*100).toFixed(2):0;
          temp[val].price_avg = temp[val].contract_cnt?(temp[val].price_total / temp[val].contract_cnt).toFixed(0):0;
          result.push(temp[val]);
        })
  
        //등록 고객 or 체결 고객이 한 명이라도 있는 것만 출력
        result = result.filter((a) => a.customer_cnt != 0 || a.contract_cnt != 0);

        //정렬()
        result.sort((a, b) => {
          //우선순위에 따른 정렬
          //1. 보험료계
          if(+(b.price_total) > +(a.price_total)) return 1;
          if(+(b.price_total) < +(a.price_total)) return -1;
  
          //2. 체결건수
          if(+(b.contract_cnt) > +(a.contract_cnt)) return 1;
          if(+(b.contract_cnt) < +(a.contract_cnt)) return -1;
  
          //3. 체결률
          if(+(b.contract_ratio) > +(a.contract_ratio)) return 1;
          if(+(b.contract_ratio) < +(a.contract_ratio)) return -1;
  
          //4. 평균 보험료
          if(+(b.price_avg) > +(a.price_avg)) return 1;
          if(+(b.price_avg) < +(a.price_avg)) return -1;
  
          //5. 고객수
          if(+(b.customer_cnt) > +(a.customer_cnt)) return 1;
          if(+(b.customer_cnt) < +(a.customer_cnt)) return -1;
          
          return 0;
        })
  
        return result;
      },

      //메인페이지 플래너별 등록/체결 현황(SNS)
      getSnsPlannerStatistics(state){
        let temp = {};
        let result = [];
        let dt = new Date();
        
        dt.setDate(1); //오늘이 31일인 경우, setMonth로 1달을 뺄 경우 전달의 31일이 돼서 다시 이번달 1일이 돼버림.. 그래서 그 전에 '일'을 1일로 변경!
  
        dt.setMonth(dt.getMonth() - state.dateParam02);
        
        let [year, month] = dt.toLocaleDateString().replaceAll(' ', '').split('.');
        let dateParam = `${year}${month}`;
        state.dateParam03 = `${year}년 ${month}월`;
        
        //각 플래너의 고객 정보 입력
        state.sCustomerInfoOrigin.reduce((_, cur) => {
          let [yy, mm] = cur.insert_date.replaceAll(' ', '').split('.');
          let ins_dt = yy + '' + mm;
  
          //입력일이 설정된 달에 해당하는지
          let isPeriod = (ins_dt == dateParam);
  
          //플래너
          let planner = cur.planner.planner01.planner_name;

          if(!temp[planner]){
            temp[planner] = {
              name: planner
              ,customer_cnt: 0
              ,contract_cnt: 0
              ,contract_ratio: 0
              ,price_total: 0
              ,price_avg: 0
            }
          }
          
          if(isPeriod){
            //고객수 ++
            temp[planner].customer_cnt = Number(temp[planner].customer_cnt) + 1;
          }

          //계약체결정보
          for(let i = 0; i < cur.contract.length; i++){
            //계약체결 여부 확인해서 체결수 ++ / 보험료 ++
            if(cur.contract[i].flag){
              let [conYY, conMM] = cur.contract[i].date.replaceAll(' ', '').split('.');
              let con_dt = conYY + '' + conMM;
              
              if(con_dt == dateParam){
                temp[planner].contract_cnt = Number(temp[planner].contract_cnt) + 1;
                temp[planner].price_total = Number(temp[planner].price_total) + Number(cur.contract[i].price.replaceAll(',', ''));
              }
            }
          }
        }, 0)
  
        //체결률, 보험료 평균 값 계산
        Object.keys(temp).forEach((val) => {
          temp[val].contract_ratio = temp[val].customer_cnt?((temp[val].contract_cnt / temp[val].customer_cnt)*100).toFixed(2):0;
          temp[val].price_avg = temp[val].contract_cnt?(temp[val].price_total / temp[val].contract_cnt).toFixed(0):0;
          result.push(temp[val]);
        })
  
        //등록 고객 or 체결 고객이 한 명이라도 있는 것만 출력
        result = result.filter((a) => a.customer_cnt != 0 || a.contract_cnt != 0);

        //정렬()
        result.sort((a, b) => {
          //우선순위에 따른 정렬
          //1. 보험료계
          if(+(b.price_total) > +(a.price_total)) return 1;
          if(+(b.price_total) < +(a.price_total)) return -1;
  
          //2. 체결건수
          if(+(b.contract_cnt) > +(a.contract_cnt)) return 1;
          if(+(b.contract_cnt) < +(a.contract_cnt)) return -1;
  
          //3. 체결률
          if(+(b.contract_ratio) > +(a.contract_ratio)) return 1;
          if(+(b.contract_ratio) < +(a.contract_ratio)) return -1;
  
          //4. 평균 보험료
          if(+(b.price_avg) > +(a.price_avg)) return 1;
          if(+(b.price_avg) < +(a.price_avg)) return -1;
  
          //5. 고객수
          if(+(b.customer_cnt) > +(a.customer_cnt)) return 1;
          if(+(b.customer_cnt) < +(a.customer_cnt)) return -1;
          
          return 0;
        })
  
        return result;
      },

      //메인페이지 플래너별 등록/체결 현황(동물병원)
      getHospitalPlannerStatistics(state){
        let temp = {};
        let result = [];
        let dt = new Date();
        
        dt.setDate(1); //오늘이 31일인 경우, setMonth로 1달을 뺄 경우 전달의 31일이 돼서 다시 이번달 1일이 돼버림.. 그래서 그 전에 '일'을 1일로 변경!
  
        dt.setMonth(dt.getMonth() - state.dateParam02);
        
        let [year, month] = dt.toLocaleDateString().replaceAll(' ', '').split('.');
        let dateParam = `${year}${month}`;
        state.dateParam03 = `${year}년 ${month}월`;
        
        //각 플래너의 고객 정보 입력
        state.hCustomerInfoOrigin.reduce((_, cur) => {
          let [yy, mm] = cur.insert_date.replaceAll(' ', '').split('.');
          let ins_dt = yy + '' + mm;
  
          //입력일이 설정된 달에 해당하는지
          let isPeriod = (ins_dt == dateParam);
  
          //플래너
          let planner = cur.planner.planner01.planner_name;

          if(!temp[planner]){
            temp[planner] = {
              name: planner
              ,customer_cnt: 0
              ,contract_cnt: 0
              ,contract_ratio: 0
              ,price_total: 0
              ,price_avg: 0
            }
          }
          
          if(isPeriod){
            //고객수 ++
            temp[planner].customer_cnt = Number(temp[planner].customer_cnt) + 1;
          }

          //계약체결정보
          for(let i = 0; i < cur.contract.length; i++){
            //계약체결 여부 확인해서 체결수 ++ / 보험료 ++
            if(cur.contract[i].flag){
              let [conYY, conMM] = cur.contract[i].date.replaceAll(' ', '').split('.');
              let con_dt = conYY + '' + conMM;
              
              if(con_dt == dateParam){
                temp[planner].contract_cnt = Number(temp[planner].contract_cnt) + 1;
                temp[planner].price_total = Number(temp[planner].price_total) + Number(cur.contract[i].price.replaceAll(',', ''));
              }
            }
          }
        }, 0)
  
        //체결률, 보험료 평균 값 계산
        Object.keys(temp).forEach((val) => {
          temp[val].contract_ratio = temp[val].customer_cnt?((temp[val].contract_cnt / temp[val].customer_cnt)*100).toFixed(2):0;
          temp[val].price_avg = temp[val].contract_cnt?(temp[val].price_total / temp[val].contract_cnt).toFixed(0):0;
          result.push(temp[val]);
        })
  
        //등록 고객 or 체결 고객이 한 명이라도 있는 것만 출력
        result = result.filter((a) => a.customer_cnt != 0 || a.contract_cnt != 0);

        //정렬()
        result.sort((a, b) => {
          //우선순위에 따른 정렬
          //1. 보험료계
          if(+(b.price_total) > +(a.price_total)) return 1;
          if(+(b.price_total) < +(a.price_total)) return -1;
  
          //2. 체결건수
          if(+(b.contract_cnt) > +(a.contract_cnt)) return 1;
          if(+(b.contract_cnt) < +(a.contract_cnt)) return -1;
  
          //3. 체결률
          if(+(b.contract_ratio) > +(a.contract_ratio)) return 1;
          if(+(b.contract_ratio) < +(a.contract_ratio)) return -1;
  
          //4. 평균 보험료
          if(+(b.price_avg) > +(a.price_avg)) return 1;
          if(+(b.price_avg) < +(a.price_avg)) return -1;
  
          //5. 고객수
          if(+(b.customer_cnt) > +(a.customer_cnt)) return 1;
          if(+(b.customer_cnt) < +(a.customer_cnt)) return -1;
          
          return 0;
        })
  
        return result;
      },

      //(미사용) 메인페이지 플래너별 고객 등록/체결 현황 - 기간 설정(최근 한 달, 한 주.. 등)
      getStatisticPeriod(state){
        let period01 = state.statisticPeriod[0];
        let period02 = state.statisticPeriod[1];
  
        if(period01 == '' && period02 == ''){
          return ['', '']
        }
  
        period01 = new Date(period01).toLocaleDateString();
        period02 = new Date(period02);
        period02 = new Date(period02.setDate(period02.getDate() - 1)).toLocaleDateString();
  
        return [period01, period02];
      },
  
      //메인페이지 일별 고객 등록/체결 현황(전체)
      getAllDateStatistics(state){
        let p1 = state.dateParam01;
        let dt1 = new Date();
        let dt2 = new Date();
        let sDt = new Date(dt1.setDate(dt1.getDate() - 4 + (1 * p1)));
        let eDt = new Date(dt2.setDate(dt2.getDate() + 1 + (1 * p1)));
        let sTime = new Date(sDt.toLocaleDateString()).getTime();
        let eTime = new Date(eDt.toLocaleDateString()).getTime();
        let dayArr = ['일', '월', '화', '수', '목', '금', '토', '일', '월', '화', '수', '목', '금', '토'];
  
        let temp = {};
  
        let result = [];
  
        for(let i = 0; i < 5; i++){
          let date = new Date(sDt.setDate(sDt.getDate() + i)).getDate();
          sDt.setDate(sDt.getDate() - i);
          let day = dayArr[sDt.getDay() + i];
          temp[`${date}(${day})`] = {date: `${date}(${day})`, data: []};
        }
        
        let aCustomerInfoOrigin = [...state.dCustomerInfoOrigin, ...state.fCustomerInfoOrigin, ...state.pCustomerInfoOrigin, ...state.sCustomerInfoOrigin];

        //원본 데이터 filter. insert_date, contract_date 가 sDt~eDt 사이인 것들만.(둘 중 하나만 해당돼도 가져오기.)
        aCustomerInfoOrigin.reduce((_, cur) => {
          let [yy, mm, dd] = cur.insert_date.split('.');
          let ins_dt = new Date(yy, mm - 1, dd).getTime();
          
          // 등록일이 포함된 경우
          if(sTime <= ins_dt && ins_dt < eTime){
            let date = new Date(ins_dt).getDate();
            let day = dayArr[new Date(ins_dt).getDay()];
            
            temp[`${date}(${day})`].data.push({planner: cur.planner.planner01.planner_name, name: cur.name??cur.pName, contractFlag: false});
          }
          
          //체결정보
          for(let i = 0; i < cur.contract.length; i++){
            let con_dt = '';
            
            if(cur.contract[i].flag){
              con_dt = new Date(cur.contract[i].date).getTime();
            }
  
            // 체결일이 포함된 경우
            if(con_dt != '' && sTime <= con_dt && con_dt < eTime){
              let date = new Date(con_dt).getDate();
              let day = dayArr[new Date(con_dt).getDay()];
              
              temp[`${date}(${day})`].data.push({planner: cur.planner.planner01.planner_name, name: cur.name??cur.pName, contractFlag: true});
            }
          }
        }, 0);
  
  
        Object.keys(temp).forEach((val) => {
          result.push(temp[val]);
        })
  
        return result;
      },

      //메인페이지 일별 고객 등록/체결 현황(치과)
      getDentalDateStatistics(state){
        let p1 = state.dateParam01;
        let dt1 = new Date();
        let dt2 = new Date();
        let sDt = new Date(dt1.setDate(dt1.getDate() - 4 + (1 * p1)));
        let eDt = new Date(dt2.setDate(dt2.getDate() + 1 + (1 * p1)));
        let sTime = new Date(sDt.toLocaleDateString()).getTime();
        let eTime = new Date(eDt.toLocaleDateString()).getTime();
        let dayArr = ['일', '월', '화', '수', '목', '금', '토', '일', '월', '화', '수', '목', '금', '토'];
  
        let temp = {};
  
        let result = [];
  
        for(let i = 0; i < 5; i++){
          let date = new Date(sDt.setDate(sDt.getDate() + i)).getDate();
          sDt.setDate(sDt.getDate() - i);
          let day = dayArr[sDt.getDay() + i];
          temp[`${date}(${day})`] = {date: `${date}(${day})`, data: []};
        }
        
        //원본 데이터 filter. insert_date, contract_date 가 sDt~eDt 사이인 것들만.(둘 중 하나만 해당돼도 가져오기.)
        state.dCustomerInfoOrigin.reduce((_, cur) => {
          let [yy, mm, dd] = cur.insert_date.split('.');
          let ins_dt = new Date(yy, mm - 1, dd).getTime();
  
          // 등록일이 포함된 경우
          if(sTime <= ins_dt && ins_dt < eTime){
            let date = new Date(ins_dt).getDate();
            let day = dayArr[new Date(ins_dt).getDay()];
            
            temp[`${date}(${day})`].data.push({planner: cur.planner.planner01.planner_name, name: cur.name, contractFlag: false});
          }
  
          //체결정보
          for(let i = 0; i < cur.contract.length; i++){
            let con_dt = '';

            if(cur.contract[i].flag){
              con_dt = new Date(cur.contract[i].date).getTime();
            }
  
            // 체결일이 포함된 경우
            if(con_dt != '' && sTime <= con_dt && con_dt < eTime){
              let date = new Date(con_dt).getDate();
              let day = dayArr[new Date(con_dt).getDay()];
              
              temp[`${date}(${day})`].data.push({planner: cur.planner.planner01.planner_name, name: cur.name, contractFlag: true});
            }
          }
        }, 0);
  
  
        Object.keys(temp).forEach((val) => {
          result.push(temp[val]);
        })
  
        return result;
      },

      //메인페이지 일별 고객 등록/체결 현황(지문)
      getFingerDateStatistics(state){
        let p1 = state.dateParam01;
        let dt1 = new Date();
        let dt2 = new Date();
        let sDt = new Date(dt1.setDate(dt1.getDate() - 4 + (1 * p1)));
        let eDt = new Date(dt2.setDate(dt2.getDate() + 1 + (1 * p1)));
        let sTime = new Date(sDt.toLocaleDateString()).getTime();
        let eTime = new Date(eDt.toLocaleDateString()).getTime();
        let dayArr = ['일', '월', '화', '수', '목', '금', '토', '일', '월', '화', '수', '목', '금', '토'];
  
        let temp = {};
  
        let result = [];
  
        for(let i = 0; i < 5; i++){
          let date = new Date(sDt.setDate(sDt.getDate() + i)).getDate();
          sDt.setDate(sDt.getDate() - i);
          let day = dayArr[sDt.getDay() + i];
          temp[`${date}(${day})`] = {date: `${date}(${day})`, data: []};
        }
        
        //원본 데이터 filter. insert_date, contract_date 가 sDt~eDt 사이인 것들만.(둘 중 하나만 해당돼도 가져오기.)
        state.fCustomerInfoOrigin.reduce((_, cur) => {
          let [yy, mm, dd] = cur.insert_date.split('.');
          let ins_dt = new Date(yy, mm - 1, dd).getTime();
          
          // 등록일이 포함된 경우
          if(sTime <= ins_dt && ins_dt < eTime){
            let date = new Date(ins_dt).getDate();
            let day = dayArr[new Date(ins_dt).getDay()];
            
            temp[`${date}(${day})`].data.push({planner: cur.planner.planner01.planner_name, name: cur.pName, contractFlag: false});
          }
          
          //체결정보
          for(let i = 0; i < cur.contract.length; i++){
            let con_dt = '';

            if(cur.contract[i].flag){
              con_dt = new Date(cur.contract[i].date).getTime();
            }
  
            // 체결일이 포함된 경우
            if(con_dt != '' && sTime <= con_dt && con_dt < eTime){
              let date = new Date(con_dt).getDate();
              let day = dayArr[new Date(con_dt).getDay()];
              
              temp[`${date}(${day})`].data.push({planner: cur.planner.planner01.planner_name, name: cur.pName, contractFlag: true});
            }
          }
        }, 0);
  
  
        Object.keys(temp).forEach((val) => {
          result.push(temp[val]);
        })
  
        return result;
      },

      //메인페이지 일별 고객 등록/체결 현황(펫)
      getPetDateStatistics(state){
        let p1 = state.dateParam01;
        let dt1 = new Date();
        let dt2 = new Date();
        let sDt = new Date(dt1.setDate(dt1.getDate() - 4 + (1 * p1)));
        let eDt = new Date(dt2.setDate(dt2.getDate() + 1 + (1 * p1)));
        let sTime = new Date(sDt.toLocaleDateString()).getTime();
        let eTime = new Date(eDt.toLocaleDateString()).getTime();
        let dayArr = ['일', '월', '화', '수', '목', '금', '토', '일', '월', '화', '수', '목', '금', '토'];
  
        let temp = {};
  
        let result = [];
  
        for(let i = 0; i < 5; i++){
          let date = new Date(sDt.setDate(sDt.getDate() + i)).getDate();
          sDt.setDate(sDt.getDate() - i);
          let day = dayArr[sDt.getDay() + i];
          temp[`${date}(${day})`] = {date: `${date}(${day})`, data: []};
        }
        
        //원본 데이터 filter. insert_date, contract_date 가 sDt~eDt 사이인 것들만.(둘 중 하나만 해당돼도 가져오기.)
        state.pCustomerInfoOrigin.reduce((_, cur) => {
          let [yy, mm, dd] = cur.insert_date.split('.');
          let ins_dt = new Date(yy, mm - 1, dd).getTime();
          
          // 등록일이 포함된 경우
          if(sTime <= ins_dt && ins_dt < eTime){
            let date = new Date(ins_dt).getDate();
            let day = dayArr[new Date(ins_dt).getDay()];
            
            temp[`${date}(${day})`].data.push({planner: cur.planner.planner01.planner_name, name: cur.name, contractFlag: false});
          }
          
          //체결정보
          for(let i = 0; i < cur.contract.length; i++){
            let con_dt = '';

            if(cur.contract[i].flag){
              con_dt = new Date(cur.contract[i].date).getTime();
            }
  
            // 체결일이 포함된 경우
            if(con_dt != '' && sTime <= con_dt && con_dt < eTime){
              let date = new Date(con_dt).getDate();
              let day = dayArr[new Date(con_dt).getDay()];
              
              temp[`${date}(${day})`].data.push({planner: cur.planner.planner01.planner_name, name: cur.name, contractFlag: true});
            }
          }
        }, 0);
  
  
        Object.keys(temp).forEach((val) => {
          result.push(temp[val]);
        })
  
        return result;
      },

      //메인페이지 일별 고객 등록/체결 현황(SNS)
      getSnsDateStatistics(state){
        let p1 = state.dateParam01;
        let dt1 = new Date();
        let dt2 = new Date();
        let sDt = new Date(dt1.setDate(dt1.getDate() - 4 + (1 * p1)));
        let eDt = new Date(dt2.setDate(dt2.getDate() + 1 + (1 * p1)));
        let sTime = new Date(sDt.toLocaleDateString()).getTime();
        let eTime = new Date(eDt.toLocaleDateString()).getTime();
        let dayArr = ['일', '월', '화', '수', '목', '금', '토', '일', '월', '화', '수', '목', '금', '토'];
  
        let temp = {};
  
        let result = [];
  
        for(let i = 0; i < 5; i++){
          let date = new Date(sDt.setDate(sDt.getDate() + i)).getDate();
          sDt.setDate(sDt.getDate() - i);
          let day = dayArr[sDt.getDay() + i];
          temp[`${date}(${day})`] = {date: `${date}(${day})`, data: []};
        }
        
        //원본 데이터 filter. insert_date, contract_date 가 sDt~eDt 사이인 것들만.(둘 중 하나만 해당돼도 가져오기.)
        state.sCustomerInfoOrigin.reduce((_, cur) => {
          let [yy, mm, dd] = cur.insert_date.split('.');
          let ins_dt = new Date(yy, mm - 1, dd).getTime();
          
          // 등록일이 포함된 경우
          if(sTime <= ins_dt && ins_dt < eTime){
            let date = new Date(ins_dt).getDate();
            let day = dayArr[new Date(ins_dt).getDay()];
            
            temp[`${date}(${day})`].data.push({planner: cur.planner.planner01.planner_name, name: cur.name, contractFlag: false});
          }
          
          //체결정보
          for(let i = 0; i < cur.contract.length; i++){
            let con_dt = '';

            if(cur.contract[i].flag){
              con_dt = new Date(cur.contract[i].date).getTime();
            }
  
            // 체결일이 포함된 경우
            if(con_dt != '' && sTime <= con_dt && con_dt < eTime){
              let date = new Date(con_dt).getDate();
              let day = dayArr[new Date(con_dt).getDay()];
              
              temp[`${date}(${day})`].data.push({planner: cur.planner.planner01.planner_name, name: cur.name, contractFlag: true});
            }
          }
        }, 0);
  
  
        Object.keys(temp).forEach((val) => {
          result.push(temp[val]);
        })
  
        return result;
      },

      //메인페이지 일별 고객 등록/체결 현황(동물병원)
      getHospitalDateStatistics(state){
        let p1 = state.dateParam01;
        let dt1 = new Date();
        let dt2 = new Date();
        let sDt = new Date(dt1.setDate(dt1.getDate() - 4 + (1 * p1)));
        let eDt = new Date(dt2.setDate(dt2.getDate() + 1 + (1 * p1)));
        let sTime = new Date(sDt.toLocaleDateString()).getTime();
        let eTime = new Date(eDt.toLocaleDateString()).getTime();
        let dayArr = ['일', '월', '화', '수', '목', '금', '토', '일', '월', '화', '수', '목', '금', '토'];
  
        let temp = {};
  
        let result = [];
  
        for(let i = 0; i < 5; i++){
          let date = new Date(sDt.setDate(sDt.getDate() + i)).getDate();
          sDt.setDate(sDt.getDate() - i);
          let day = dayArr[sDt.getDay() + i];
          temp[`${date}(${day})`] = {date: `${date}(${day})`, data: []};
        }
        
        //원본 데이터 filter. insert_date, contract_date 가 sDt~eDt 사이인 것들만.(둘 중 하나만 해당돼도 가져오기.)
        state.hCustomerInfoOrigin.reduce((_, cur) => {
          let [yy, mm, dd] = cur.insert_date.split('.');
          let ins_dt = new Date(yy, mm - 1, dd).getTime();
          
          // 등록일이 포함된 경우
          if(sTime <= ins_dt && ins_dt < eTime){
            let date = new Date(ins_dt).getDate();
            let day = dayArr[new Date(ins_dt).getDay()];
            
            temp[`${date}(${day})`].data.push({planner: cur.planner.planner01.planner_name, name: cur.name, contractFlag: false});
          }
          
          //체결정보
          for(let i = 0; i < cur.contract.length; i++){
            let con_dt = '';

            if(cur.contract[i].flag){
              con_dt = new Date(cur.contract[i].date).getTime();
            }
  
            // 체결일이 포함된 경우
            if(con_dt != '' && sTime <= con_dt && con_dt < eTime){
              let date = new Date(con_dt).getDate();
              let day = dayArr[new Date(con_dt).getDay()];
              
              temp[`${date}(${day})`].data.push({planner: cur.planner.planner01.planner_name, name: cur.name, contractFlag: true});
            }
          }
        }, 0);
  
  
        Object.keys(temp).forEach((val) => {
          result.push(temp[val]);
        })
  
        return result;
      },
  
      //메인페이지 일별 고객 등록/체결 현황 시작일 계산
      getStartDt(state){
        let p1 = state.dateParam01;
        let dt1 = new Date();
        let sDt = new Date(dt1.setDate(dt1.getDate() - 4 + (1 * p1))).toLocaleDateString();
  
        return sDt;
      },
  
      //메인페이지 일별 고객 등록/체결 현황 종료일 계산
      getEndDt(state){
        let p1 = state.dateParam01;
        let dt2 = new Date();
        let eDt = new Date(dt2.setDate(dt2.getDate() + (1 * p1))).toLocaleDateString();
  
        return eDt;
      },
  
      //고객 정보 조회(고객정보 페이지에서)
      getCustomerInfo(state){
        //검색어가 있는 경우
        if(state.searchText != ''){
  
          let text = state.searchText;
          let temp = [];

          if(state.dbKind == 'dental'){
            state.dCustomerInfoOrigin.forEach(a => {
              if(a.name.indexOf(text) > -1 || a.decrypt_regist_number.indexOf(text) > -1 || a.phone.phone.indexOf(text) > -1 || a.phone.telecom.indexOf(text) > -1 || a.address.address.indexOf(text) > -1
              || a.address.detail_address.indexOf(text) > -1 || a.address.extra_address.indexOf(text) > -1 || a.planner.planner01.planner_name.indexOf(text) > -1 
              || a.hospital_info.introducer.indexOf(text) > -1 || a.hospital_info.hospital.indexOf(text) > -1 || a.hospital_info.cure.indexOf(text) > -1){
                temp.push(a);
              }
            });
            state.dCustomerInfo = temp;

          }else if(state.dbKind == 'finger'){
            state.fCustomerInfoOrigin.forEach(a => {
              if(a.pName.indexOf(text) > -1 || a.cName.indexOf(text) > -1 || a.phone.phone.indexOf(text) > -1 || a.phone.telecom.indexOf(text) > -1
                || a.area.indexOf(text) > -1 || a.childProp.indexOf(text) > -1|| a.planner.planner01.planner_name.indexOf(text) > -1 ){
                temp.push(a);
              }
            });
            state.fCustomerInfo = temp;

          }else if(state.dbKind == 'pet'){
            state.pCustomerInfoOrigin.forEach(a => {
              if(a.name.indexOf(text) > -1  || a.decrypt_regist_number.indexOf(text) > -1 || a.phone.phone.indexOf(text) > -1 || a.phone.telecom.indexOf(text) > -1 || a.address.address.indexOf(text) > -1
                || a.address.detail_address.indexOf(text) > -1 || a.address.extra_address.indexOf(text) > -1 || a.planner.planner01.planner_name.indexOf(text) > -1 
                || JSON.stringify(a.petInfo??'').indexOf(text) > -1 ){
                temp.push(a);
              }
            });
            state.pCustomerInfo = temp;

          }else if(state.dbKind == 'sns'){
            state.sCustomerInfoOrigin.forEach(a => {
              if(a.name.indexOf(text) > -1  || a.decrypt_regist_number.indexOf(text) > -1 || a.phone.phone.indexOf(text) > -1 || a.phone.telecom.indexOf(text) > -1 || a.address.address.indexOf(text) > -1
                || a.address.detail_address.indexOf(text) > -1 || a.address.extra_address.indexOf(text) > -1 || a.planner.planner01.planner_name.indexOf(text) > -1 
                || JSON.stringify(a.petInfo??'').indexOf(text) > -1 ){
                temp.push(a);
              }
            });
            state.sCustomerInfo = temp;

          }else if(state.dbKind == 'hospital'){
            state.hCustomerInfoOrigin.forEach(a => {
              if(a.name.indexOf(text) > -1  || a.decrypt_regist_number.indexOf(text) > -1 || a.phone.phone.indexOf(text) > -1 || a.phone.telecom.indexOf(text) > -1 || a.address.address.indexOf(text) > -1
                || a.address.detail_address.indexOf(text) > -1 || a.address.extra_address.indexOf(text) > -1 || a.planner.planner01.planner_name.indexOf(text) > -1 
                || JSON.stringify(a.petInfo??'').indexOf(text) > -1 || JSON.stringify(a.petAlert??'').indexOf(text) > -1 ){
                temp.push(a);
              }
            });
            state.hCustomerInfo = temp;

          }
          
          
  
        }else{//검색어가 없는 경우
          switch(state.dbKind){
            case 'dental':
              state.dCustomerInfo = state.dCustomerInfoOrigin;
              break;
            case 'finger':
              state.fCustomerInfo = state.fCustomerInfoOrigin;
              break;
            case 'pet':
              state.pCustomerInfo = state.pCustomerInfoOrigin;
              break;
            case 'sns':
              state.sCustomerInfo = state.sCustomerInfoOrigin;
              break;
            case 'hospital':
              state.hCustomerInfo = state.hCustomerInfoOrigin;
              break;
            default:
              state.dCustomerInfo = state.dCustomerInfoOrigin;
              state.fCustomerInfo = state.fCustomerInfoOrigin;
              state.pCustomerInfo = state.pCustomerInfoOrigin;
              state.sCustomerInfo = state.sCustomerInfoOrigin;
              state.hCustomerInfo = state.hCustomerInfoOrigin;
              break;
          }
        }

        if(state.isFavorite){
          switch(state.dbKind){
            case 'dental':
              state.dCustomerInfo = state.dCustomerInfo.filter((a) => a.isFavorite);
              break;
            case 'finger':
              state.fCustomerInfo = state.fCustomerInfo.filter((a) => a.isFavorite);
              break;
            case 'pet':
              state.pCustomerInfo = state.pCustomerInfo.filter((a) => a.isFavorite);
              break;
            case 'sns':
                state.sCustomerInfo = state.sCustomerInfo.filter((a) => a.isFavorite);
                break;
            case 'hospital':
                state.hCustomerInfo = state.hCustomerInfo.filter((a) => a.isFavorite);
                break;
            default:
              state.dCustomerInfo = state.dCustomerInfo.filter((a) => a.isFavorite);
              state.fCustomerInfo = state.fCustomerInfo.filter((a) => a.isFavorite);
              state.pCustomerInfo = state.pCustomerInfo.filter((a) => a.isFavorite);
              state.sCustomerInfo = state.sCustomerInfo.filter((a) => a.isFavorite);
              state.hCustomerInfo = state.hCustomerInfo.filter((a) => a.isFavorite);
              break;
          }
        }
  
        return state.dbKind == 'dental' ? state.dCustomerInfo : state.dbKind == 'finger' ? state.fCustomerInfo : state.dbKind == 'pet' ? state.pCustomerInfo : state.dbKind == 'sns' ? state.sCustomerInfo : state.hCustomerInfo;
      },
    }
  }

  export default customerStore;